import Onboarding, {
  IOnboardingFile,
  IOnboardingFileApi,
} from '@models/Onboarding.model';
import { onboarding } from '@services';

interface IRequest {
  studioId: string;
  studioName: string;
  file?: File;
  triggeredById?: string;
  triggeredByAvatar?: string;
  triggeredBy?: string;
  triggeredByEmail?: string;
}

const fileUpload = async ({
  file,
  studioId,
  studioName,
  triggeredById,
  triggeredByAvatar,
  triggeredBy,
  triggeredByEmail,
}: IRequest): Promise<IOnboardingFile> => {
  const formData = new FormData();

  if (file) formData.append('file', file);
  if (triggeredById) formData.append('triggeredById', triggeredById);
  if (triggeredByAvatar)
    formData.append('triggeredByAvatar', triggeredByAvatar);
  if (triggeredBy) formData.append('triggeredBy', triggeredBy);
  if (triggeredByEmail) formData.append('triggeredByEmail', triggeredByEmail);

  const { data: onboardingFile } = await onboarding.post<IOnboardingFileApi>(
    `/api/v1/file/upload?studioId=${studioId}&studioName=${studioName}`,
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    },
  );

  return Onboarding.fromApiModel(onboardingFile);
};

export { fileUpload };
